export default __webpack_public_path__ + "static/media/singular.2b951861.png";